import { useSearchParams } from "react-router-dom";

export const useCommonDashboardHook = () => {
  const [searchParams] = useSearchParams();
  const startDate = (from: string) => searchParams.get(from) || "";

  const endDate = (to: string) => searchParams.get(to) || "";

  return {
    startDate,
    endDate,
    searchParams,
  };
};
